// Session Service - re-reads the current session from the server (role, status, solutions)

import { apiGet } from '@/utils/api';
import { UserRole, UserStatus } from '@/types/global.types';

export interface SessionSnapshot {
  id: string;
  email: string | null;
  username: string | null;
  firstName: string;
  lastName: string;
  role: UserRole;
  status: UserStatus;
  tenantId: string | null;
  isAlsoProfessor: boolean;
  enabledSolutions: string[];
}

/**
 * Current session as the DATABASE sees it. Unlike the login response, this is
 * never cached: it is how a role change made by an admin reaches an open session.
 */
export async function fetchSessionSnapshot(): Promise<SessionSnapshot> {
  return apiGet<SessionSnapshot>('/auth/me');
}
